import React from 'react';

import {Box, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {styleInZoomClient} from 'Utils/integration';
import zoomPalette from 'zoomPalette';

/**
 * Beta Badge Component
 * @param {Object} props
 * @param {String} props.text
 * @return {ReactElement}
 */
export default function BetaBadge({isRoundStyle, sx, text = 'common.beta'} = {}) {
  const {t} = useTranslation();
  return (
    <Box
      sx={{
        height: '16px',
        display: 'inline-flex',
        padding: '0px 4px',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: (styleInZoomClient && !isRoundStyle)? '3px 6px 3px 6px': '100px',
        color: zoomPalette.white,
        // eslint-disable-next-line max-len
        background: (styleInZoomClient && !isRoundStyle)? 'linear-gradient(45deg, #0E72ED 0%, #925DFF 100%)': 'linear-gradient(81deg, #493AB7 0%, #925DFF 100%)',
        ...sx,
      }}
    >
      <Typography
        sx={{
          fontSize: '12px',
          fontWeight: '400',
          lineHeight: '16px',
        }}
      >
        {t(text).toUpperCase()}
      </Typography>
    </Box>
  );
};
